<template>
  <b-modal
    v-model="dataModal"
    centered
    no-close-on-backdrop
    no-close-on-esc
    title="Reactivate Project"
    @close="onCloseModal">
    <div>
      Are you sure you want to reactivate the project ?
    </div>
    <template #modal-footer>
      <call-button
        :icon="dataCloseIcon"
        type="danger"
        plain
        @click="onCloseModal()">
        Cancel
      </call-button>
      <call-button
        :icon="dataUnlockIcon"
        type="success"
        @click="clickReactivate()">
        Reactivate
      </call-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import CallButton from '../CallButton';
import { PROJECTS_UNBLOCKED } from '../../../store/types/actions.types';
import iconsModal from '../../../mixins/iconsModal';
import { faBackward } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'CallReactiveProject',
  components: {
    CallButton,
    BModal
  },
  mixins: [iconsModal],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      dataModal: this.value,
      dataUnlockIcon: faBackward
    };
  },
  watch: {
    async value () {
      this.dataModal = this.value;
    }
  },
  methods: {
    onCloseModal () {
      this.$emit('input', false);
    },
    async clickReactivate () {
      try {
        await this.$store.dispatch(`project/${PROJECTS_UNBLOCKED}`, {
          params: {
            projectId: this.projectId
          }
        });
        this.$Notify({
          title: 'Project',
          message: 'Successfully Reactivated',
          type: 'success'
        });
        this.onCloseModal();
        this.$emit('on-update');
      } catch (e) {
        throw Error('Ошибка реактивации');
      }
    }
  }
};
</script>
